import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4752fe46&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&setup=true&"
export * from "./index.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./index.vue?vue&type=style&index=0&id=4752fe46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4752fe46",
  null
  
)

export default component.exports